import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll al inicio de la página cuando cambia la ruta o los parámetros de búsqueda
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Usamos instant para que no haya salto visual molesto durante la navegación
    });
  }, [pathname, search]);

  return null;
}
